<template>
    <button :type="type" @click="$emit('click', $event.target.value)" class="inline-flex items-center justify-center px-4 py-2 text-base font-medium text-white transition duration-150 ease-in-out border border-transparent rounded-md bg-teal focus:outline-none" :class="{ 'pointer-events-none opacity-50': $attrs.disabled || busy }" :disabled="$attrs.disabled || busy">
        <svg v-if="busy" class="w-5 h-5 mr-2 -ml-1 text-white animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-hidden="true">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
        </svg>

        <slot />
    </button>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: 'button',
        },
        busy: {
            type: Boolean,
            default: false
        }
    },
    emits: ['click']
}
</script>
